export class ITransition {
  id?: number;
  timestamp?: Date | string;
  transition?: string;
  user?: string;
  source_state?: string;
  state?: string;
}
export class Transition {
  id?: number;
  timestamp?: Date | string;
  transition?: string;
  user?: string;
  source_state?: string;
  state?: string;

  constructor(data?: ITransition) {
    if (data) {
      if (data.id) {
        this.id = data.id;
      }
      if (data.timestamp) {
        this.timestamp = data.timestamp;
      }
      if (data.transition) {
        this.transition = data.transition;
      }
      if (data.user) {
        this.user = data.user;
      }
      if (data.source_state) {
        this.source_state = data.source_state;
      }
      if (data.state) {
        this.state = data.state;
      }
    }
  }

  get userInitials() {
    return this.user!.toUpperCase()
      .split(' ')
      .map(n => n[0])
      .join('');
  }
}
